// color settings

// grey scheme
const lightGrey = "rgb(235, 235, 235)";
const lightishGrey = "rgb(170, 170, 170)";
// const lightGreen = "rgb(205, 235, 205)";
const lightBlue = "rgb(208, 208, 255)";
// const midBlue = "rgb(128, 128, 255)";


export const color = {
  company: "white", // lightGrey, // light grey
  officer: "white", // lightGrey, // light grey
  person: "white", // lightGrey, // light grey
  officerLink: "black",
  pscLink: lightishGrey, // "grey", // midBlue,
  psc: lightBlue, // light blue
  nonCurrent: lightGrey, // light grey
  borderStandard: "rgb(150, 150, 150)", // dark grey
  borderHighlight: "rgb(206, 167, 255)", // light blue
  nodeTooltipBackground: "rgb(216, 175, 255)", // light purple
  nodeTooltipNonCurrentText: "rgb(80, 80, 80)", // dark grey
}

// layout and appearance constants
export const layout = {  
  nodeRadiusFactor: 0.25,
  nodeScale: [1, 0.9, 0.8],
  officerCircleFactor: 1,
  linkWidthFactor: 0.015,
  nonDirectorLinkWidthFactor: 1.5,
  pscLinkWidthFactor: 3, // 2.5,
  linkZoneWidthFactor: 12,
  xPaddingProportion: 0.04,
  xPadding: 20,
  yPaddingProportion: 0.03,
  yPadding: 32,
  nodeEdgeMargin: 10, // min distance (px) kept between a node circle's edge and the diagram area's perimeter
  hoverNodeTooltip: true,
  mobileTooltip: false,
  tooltipSizeFactor: 0.225,

  fontSizeFactor: 0.03,
  maxFontSize: 18,
  labelFontFactor: 0.19,
  titleSizeFactor: 1.2,

  buttonWidthFactor: 0.12,
  buttonHeightFactor: 2.7,
  buttonTtScale: 0.25,
}

// timing and simulation values
export const timing = {
  slow: 500, // 500                  // time in msecs for slow D3 transitions
  fast: 250, // 250                  // time in msecs for fast D3 transitions
}

export const simConfig = {
  // node control
  collisionStrength: 0.6,      // 0.5,  // higher value forces nodes apart, but can cause vibration
  collisionRadiusFactor: 1.02, // 1.1   // higher value spaces node further apart

  //link control
  linkDistanceFactor: 0.32,   // 0.32, // length of link to which simulation tries to push/pull linked nodes
  linkStrength: 1,            // 1.5,  // higher value increases force pulling linked nodes to specified distance apart, but gives more vibration of nodes when there are many

  // position control - gently recalls each node towards the angular slot assigned by setNodeAngles.js
  // (see nexusDataPrep.js's node ordering), so charge/collision/link forces don't scramble the
  // crossing-reducing arrangement as the simulation settles. Too high a value fights the other forces
  // and makes nodes vibrate/overlap; too low and nodes drift freely, undoing the ordering.
  positionRecallStrength: 0.15,

  // movement control
  velocityDecay: 0.6,         // 0.7 higher value gives slower movement of nodes
  alphaStart: 1,              // 1 the starting value of alpha
  alphaTarget: 0,             // 0.2 the value to which alpha approaches as it decays
  alphaMin: 0.05,             // 0.21 the threshold value that alpha decreases to before movement stops
  alphaDecay: 0.05,           // 0.01 determines how quickly the current alpha interpolates towards the desired target alpha

  // drag control
  minDrag: 10,                // square of min distance for drag that disables click
}

export const connectionInfoLayout = {
  maxWidth: 350, // 420,
  maxHeight: 220,
  proportion: 0.85,
  xPadding: 12,
  yPadding: 10,
  xMargin: 18,
  yMargin: 140,
  cornerRadiusFactor: 0.02,
  opacity: 0.9,
  fontSize: 14,
}

